$(document).on('turbolinks:load', function () {
  const modal_holder_selector = '#modal-holder';
  const modal_selector = '.modal';

  $(document).on('click', 'a[data-modal]', function () {
    const location = $(this).attr('href');
    // Load modal dialog from server
    $.get(location, (data) => {
      $(modal_holder_selector).html(data).find(modal_selector).modal('show');
      flatpickr('.time_picker', {
        enableTime: true,
        noCalendar: true,
        altInput: true,
        dateFormat: 'm/d/Y H:i',
      });
      flatpickr('.only_time_picker', {
        enableTime: true,
        noCalendar: true,
        altInput: true,
        dateFormat: 'H:i K',
      });
      $('.validate').validate();
      $('#sortable').sortable({
        update: function (event, ui) {
          var pos = ui.item.index();
          var url = ui.item.data('sort-url');
          console.log(url, ui);
          $.ajax({
            type: 'POST',
            url: url,
            data: { position: pos },
            success: function (data, textStatus, jqXHR) { },
          });
        },
      });
    });
    $(document).on('hidden.bs.modal', '#mainModal', function (e) {
      $('.modal-backdrop').remove();
    });
    return false;
  });


  $(document).on('click', 'a[data-modal-flat]', function () {
    const location = $(this).attr('href');
    // Load modal dialog from server
    if ($(this).attr("data-disabled") === "true") {
      return false;
    }
    $.get(location, (data) => {
      if (data?.error) {
        $('#invalid_case').text(data.error);
        $('#invalid_case').show();
        setTimeout(function () {
          $('#invalid_case').hide();
          window.location.reload();
        }, 5000);
      } else {
        $(modal_holder_selector).html(data).find(modal_selector).modal('show');
      }

    });
    $(document).on('hidden.bs.modal', '#mainModal', function (e) {
      $('.modal-backdrop').remove();
    });
    return false;
  });

  // this targets only clicks inside #cartDropdown
  $('#cartDropdown').on('click', '[data-modal-flat]', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const location = this.href;

    $.get(location, (data) => {
      if (data?.error) {
        $('#invalid_case').text(data.error).show();
        setTimeout(function () {
          $('#invalid_case').hide();
          window.location.reload();
        }, 5000);
      } else {
        $(modal_holder_selector).html(data).find(modal_selector).modal('show');
      }
    });
  });

  $(document).on('ajax:success', 'form[data-modal]', function (event) {
    const [data, _status, xhr] = event.detail;
    const url = xhr.getResponseHeader('Location');
    if (url) {
      // Redirect to url
      window.location = url;
    } else {
      // Remove old modal backdrop
      $('.modal-backdrop').remove();
      // Update modal content
      const modal = $(data).find('body').html();
      $(modal_holder_selector).html(modal).find(modal_selector).modal();
    }
    $(document).on('hidden.bs.modal', '#mainModal', function (e) {
      $('.modal-backdrop').remove();
    });

    return false;
  });
});
